import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import getAvatarUrl from "../../../../utils/get-avatar-url";

const CopyMealPlanToAthleteSelector = ({
  assignedMealPlans,
  athletes,
  allAthletesFromOrganization,
  updateState,
  webAppTheme,
  selectedAthlete,
}) => {
  const { t } = useTranslation("coaching-portal");
  const [searchValue, setSearchValue] = useState(""); //this is to filter the values in the "search input"

  const athletesList = useMemo(() => {
    const assignedAthleteIds = new Set(
      assignedMealPlans.map(({ athleteId }) => athleteId)
    );
    const activeAthletes = athletes
      .filter(
        ({ status, _id }) => !status?.inactive && assignedAthleteIds.has(_id)
      )
      .map(({ _id, name, avatar }) => ({
        value: _id,
        label: name,
        avatar: avatar,
      }));

    const activeOrgAthletes = allAthletesFromOrganization
      .filter(
        ({ athleteStatus, athleteId }) =>
          !athleteStatus?.inactive && assignedAthleteIds.has(athleteId)
      )
      .map(({ athleteId, athleteName, athleteAvatar }) => ({
        value: athleteId,
        label: athleteName,
        avatar: athleteAvatar,
      }));

    const uniqueAthletes = new Map(
      [...activeAthletes, ...activeOrgAthletes].map((item) => [
        item.value,
        item,
      ])
    );

    return Array.from(uniqueAthletes.values()).sort((a, b) =>
      a.label.localeCompare(b.label)
    );
  }, [athletes, allAthletesFromOrganization, assignedMealPlans]);

  const filteredAthletesList = useMemo(() => {
    return searchValue
      ? athletesList.filter(({ label }) =>
          label.toLowerCase().startsWith(searchValue.toLowerCase())
        )
      : athletesList;
  }, [searchValue, athletesList]);

  return (
    <div className="athletes-container">
      <input
        className="input-search"
        placeholder={t("allTemplates.copyMealPlanToAthleteSelector.searchPlaceholder")}
        value={searchValue}
        type="search"
        onChange={({ target: { value } }) => setSearchValue(value)}
      />
      <ul>
        {filteredAthletesList?.map(({ value, label, avatar }, index) => (
          <li
            key={value}
            className={selectedAthlete === value ? "selected" : ""}
          >
            <button
              onClick={() =>
                updateState({
                  selectedAthlete: value,
                  selectedWeeksByTemplate: {},
                })
              }
            >
              <img
                src={getAvatarUrl({ avatar }, false, webAppTheme)}
                alt="avatar"
              />
              <span>{label}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

CopyMealPlanToAthleteSelector.propTypes = {
  assignedMealPlans: PropTypes.array,
  athletes: PropTypes.array,
  allAthletesFromOrganization: PropTypes.array,
  updateState: PropTypes.func,
  webAppTheme: PropTypes.string,
  selectedAthlete: PropTypes.string,
};

export default CopyMealPlanToAthleteSelector;
